<div
  class="flex justify-center my-16 w-full"
  style="border-bottom: grey 1px solid"
>
  <h1 class="">Pressure Test Certificate</h1>
</div>

<div [formGroup]="pressureTestCerificateEmailFormGroup">
  <div class="flex justify-between" fxLayout="row wrap">
    <mat-form-field class="w-45 px-16 py-4 mx-16" style="width: 400px">
      <input matInput placeholder="To: " formControlName="emailToAddress" />
    </mat-form-field>
    <span fxFlex></span>
    <div>
      <img src="../../../assets/dlm-images/logos/pdf-icon.ico" />
    </div>
  </div>

  <div class="flex justify-between" fxLayout="row wrap">
    <mat-form-field class="w-45 px-16 py-4 mx-16" style="width: 400px">
      <input
        matInput
        placeholder="Subject: "
        formControlName="subjectOfEmail"
      />
    </mat-form-field>
  </div>

  <div class="flex justify-center" fxLayout="row wrap">
    <mat-form-field class="p-16 mx-16 w-full">
      <textarea
        matInput
        placeholder="Email Body"
        formControlName="emailBody"
        style="height: 350px"
      >
      </textarea>
    </mat-form-field>
  </div>
</div>

<div class="flex fixed-width my-8" style="border-top: grey 1px solid">
  <button
    mat-flat-button
    color="primary"
    class="my-16 mx-8"
    (click)="cancelEmailPDF()"
  >
    Cancel
  </button>
  <button
    mat-flat-button
    color="primary"
    class="my-16 ml-8 mr-32"
    (click)="sendEmailPDF()"
  >
    Send
  </button>
</div>
